export function isNativeReisorTransport(item = {}) {
  return String(item?.source || "").trim().toUpperCase() === "REISOR_USER";
}

function normalizedDescriptor(item = {}) {
  return [
    item?.assetType,
    item?.assetSubtype,
    item?.performerCategory,
    item?.bodyType,
    item?.bodyTypeOther,
    item?.vehicle?.car,
    item?.vehicle?.carBrand,
    item?.vehicle?.carModel,
  ]
    .map((value) => String(value || "").trim().toLowerCase())
    .filter(Boolean)
    .join(" ");
}

export function reisorTransportVisualKind(item = {}) {
  const value = normalizedDescriptor(item);

  if (/трактор|tractor/.test(value)) return "TRACTOR";
  if (/реф|reefer|refriger|холод|isotherm|изотерм/.test(value)) return "REEFER";
  if (/эвакуатор|tow[_ -]?truck|tow truck/.test(value)) return "TOW";
  if (/автобус|microbus|микроавтобус|bus|passenger/.test(value)) return "BUS";
  if (/газел|gazel|labo|bongo|фургон|furgon|van|minivan/.test(value)) return "VAN";
  if (/спец|special|экскават|кран|crane|excavat|loader|погруз|forklift|bulldozer/.test(value)) return "SPECIAL";
  if (/фура|тягач|тент|tent|curtain|semi|trailer|штора/.test(value)) return "FURA";
  if (/car|sedan|легков/.test(value)) return "CAR";
  return "TRUCK";
}

export function nativeTransportPrimaryLabel(item = {}, fallback = "REISOR транспорт") {
  const fullName = String(item?.fullName || "").trim();
  if (fullName) return fullName;

  const car = String(item?.vehicle?.car || "").trim();
  if (car) return car;

  const model = [item?.vehicle?.carBrand, item?.vehicle?.carModel]
    .map((value) => String(value || "").trim())
    .filter(Boolean)
    .join(" ");

  return model || fallback;
}
